exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-card[data-v-683512be]{width:240px;margin:4px;display:inline-block;vertical-align:top;word-wrap:break-word}.md-card-content[data-v-683512be]{padding-left:0}.md-switch[data-v-683512be]{margin:25px 16px 16px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-683512be","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserLogs.vue
// module id = 214
// module chunks = 0